<a href="javascript:;" (click)="downloadFile()" [innerHTML]="rawHtml"></a>
